import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  content: PropTypes.string.isRequired,
  closeText: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

const defaultProps = {
  closeText: '확인',
  title: '',
  onClose() {},
};

function InvalidPhoneNumberModal({ title, content, closeText, onClose }) {
  const { t } = useTranslation();

  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop align-center box-6x">
        {title && (
          <h4 className="space-2x" data-testid="basic-modal-title">
            <strong>{title}</strong>
          </h4>
        )}
        <p className="space-4x" data-testid="basic-modal-content">
          {content.split('\n').map((v, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index}>
              {v}
              <br />
            </span> // eslint-disable-line react/no-array-index-key
          ))}
        </p>
        <a
          href="https://support.modusign.co.kr/hc/ko/articles/360000991088"
          rel="noopener noreferrer"
          target="_blank"
        >
          <button className="Btn Btn--bold-mobile" type="button">
            {t('InvalidPhoneNumberModal-troubleshooting')} {'>'}
          </button>
        </a>
        <button
          className="Btn Btn--primary Btn--bold-mobile"
          type="button"
          onClick={() => onClose()}
        >
          {closeText}
        </button>
      </div>
    </div>
  );
}

InvalidPhoneNumberModal.propTypes = propTypes;
InvalidPhoneNumberModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  onClose: modalClose,
};

export default connect(null, mapDispatchToProps)(InvalidPhoneNumberModal);
